<kodit-dropdown
  (optionChanged)="handleOnItemChange($event)"
  [formCtrlId]="formCtrlId"
  [options]="items"
  ctrlTooltip="Identifikacija kupca"
  [formCtrl]="formCtrl"
></kodit-dropdown>
